import { StateShape } from "../reducers";

export function getSplitIoIsBroken(state: StateShape) {
  return state.app.splitIoIsBroken;
}
